import * as React from 'react';
import { useSelector } from 'react-redux';

import { isDealRent } from '../../selectors/isDealRent';
import { DealRentNotice } from '../../components/DealRentNotice';

export const DealRentNoticeContainer: React.FC = () => {
  const isDealRentOffer = useSelector(isDealRent);

  if (!isDealRentOffer) {
    return null;
  }

  return <DealRentNotice />;
};
